import { render } from "./Layout.vue?vue&type=template&id=b4cc8408"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"

import "./Layout.vue?vue&type=style&index=0&id=b4cc8408&lang=css"

import exportComponent from "D:\\Wyspace\\WechatPlatForm_XINXIN\\WechatPlatForm\\Vue.EmployApply\\employVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__